import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Select,
  FormControl,
  useTheme,
} from "@mui/material";
import { BaseStepProps } from "../types/types";
import { tokens } from "../../../theme";

interface BasicInfoProps extends BaseStepProps {
  onNext: () => void;
}

export default function Step1BasicInfo({
  formData,
  onChange,
  onNext,
  onSaveGear,
}: BasicInfoProps) {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Gear Name *
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. Sony Camera"
            size="small"
            value={formData.name}
            onChange={(e) => onChange("name", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Brand
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. Sony"
            size="small"
            value={formData.brand}
            onChange={(e) => onChange("brand", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Serial Number
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. SN-1234"
            size="small"
            value={formData.serialNo}
            onChange={(e) => onChange("serialNo", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Category
          </Typography>
          <FormControl
            fullWidth
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          >
            <Select
              displayEmpty
              value={formData.category}
              onChange={(e) => onChange("category", e.target.value)}
              renderValue={(s) =>
                s ? (
                  s
                ) : (
                  <Typography sx={{ color: "#A0938D" }}>
                    Select Category here
                  </Typography>
                )
              }
            >
              <MenuItem value="Camera">Camera</MenuItem>
              <MenuItem value="Lighting">Lighting</MenuItem>
              <MenuItem value="Internet">Internet</MenuItem>
              <MenuItem value="Accessories">Accessories</MenuItem>
              <MenuItem value="Lenses">Lenses</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Status
          </Typography>
          <FormControl
            fullWidth
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          >
            <Select
              displayEmpty
              value={formData.status}
              onChange={(e) => onChange("status", e.target.value)}
              renderValue={(s) =>
                s ? (
                  s
                ) : (
                  <Typography sx={{ color: "#A0938D" }}>
                    Select Status here
                  </Typography>
                )
              }
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Available">Available</MenuItem>
              <MenuItem value="Under Maintenance">Under Maintenance</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Model
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. FX6"
            size="small"
            value={formData.model}
            onChange={(e) => onChange("model", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>

      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: colors.primary[400],
            mb: 0.5,
            fontSize: "0.88rem",
          }}
        >
          Manufacture
        </Typography>
        <TextField
          fullWidth
          placeholder="e.g. Sony"
          size="small"
          value={formData.manufacture}
          onChange={(e) => onChange("manufacture", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: colors.primary[800],
              borderRadius: "16px",
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
          }}
        />
      </Box>

      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: colors.primary[400],
            mb: 0.5,
            fontSize: "0.88rem",
          }}
        >
          Location
        </Typography>
        <TextField
          fullWidth
          placeholder="e.g. Gourmanet Garage"
          size="small"
          value={formData.location}
          onChange={(e) => onChange("location", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: colors.primary[800],
              borderRadius: "16px",
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
          }}
        />
      </Box>


      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3 }}>
          <Typography
            onClick={onSaveGear}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Save Gear
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={onNext}
          sx={{
            backgroundColor: colors.primary[400],
            px: 5,
            py: 1.2,
            borderRadius: "24px",
            "&:hover": { backgroundColor: colors.primary[500] },
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}
